      <!-- Step 1: Welcome -->
      <div *ngIf="view.currentStep === 0" class="step-welcome" id="wizard-step-welcome">
        <h1 class="step-title" id="wizard-step-welcome-title">{{ view.translate(view.steps[view.currentStep].title) }}</h1>
        <p class="step-description" id="wizard-step-welcome-description">{{ view.translate(view.steps[view.currentStep].description) }}</p>

        <div class="invite-info-box">
          <div class="invite-info-item">
            <i class="fas fa-envelope"></i>
            <div>
              <span class="info-label">{{ view.translate('invite.email') }}</span>
              <span class="info-value">{{ view.invite?.email }}</span>
            </div>
          </div>
          <div class="invite-info-item">
            <i class="fas fa-building"></i>
            <div>
              <span class="info-label">{{ view.translate('invite.company') }}</span>
              <span class="info-value">{{ view.invite?.companyName }}</span>
            </div>
          </div>
          <div class="invite-info-item">
            <i class="fas fa-user-tag"></i>
            <div>
              <span class="info-label">{{ view.translate('invite.role') }}</span>
              <span class="info-value">{{ view.invite?.roleName }}</span>
            </div>
          </div>
        </div>

        <div class="welcome-features" id="wizard-welcome-features">
          <div class="feature-item" id="wizard-feature-chat">
            <i class="fas fa-robot" id="wizard-feature-chat-icon"></i>
            <h3 id="wizard-feature-chat-title">{{ view.translate('wizard.feature_chat_title') }}</h3>
            <p id="wizard-feature-chat-desc">{{ view.translate('wizard.feature_chat_desc') }}</p>
          </div>
          <div class="feature-item" id="wizard-feature-docs">
            <i class="fas fa-file-alt" id="wizard-feature-docs-icon"></i>
            <h3 id="wizard-feature-docs-title">{{ view.translate('wizard.feature_docs_title') }}</h3>
            <p id="wizard-feature-docs-desc">{{ view.translate('wizard.feature_docs_desc') }}</p>
          </div>
          <div class="feature-item" id="wizard-feature-insights">
            <i class="fas fa-chart-line" id="wizard-feature-insights-icon"></i>
            <h3 id="wizard-feature-insights-title">{{ view.translate('wizard.feature_insights_title') }}</h3>
            <p id="wizard-feature-insights-desc">{{ view.translate('wizard.feature_insights_desc') }}</p>
          </div>
        </div>
      </div>

      <!-- Step 2: Preferences -->
      <div *ngIf="view.currentStep === 1" class="step-preferences" id="wizard-step-preferences">
        <h1 class="step-title" id="wizard-step-preferences-title">{{ view.translate(view.steps[view.currentStep].title) }}</h1>
        <p class="step-description" id="wizard-step-preferences-description">{{ view.translate(view.steps[view.currentStep].description) }}</p>

        <form [formGroup]="view.wizardForm" class="preferences-form" id="wizard-preferences-form">
          <!-- Theme selection -->
          <div class="preference-section" id="wizard-theme-section">
            <h3 id="wizard-theme-title">{{ view.translate('wizard.theme_preference') }}</h3>
            <div class="theme-selector" id="wizard-theme-selector">
              <button type="button" class="btn theme-btn light-btn"
                [ngClass]="{'active': view.wizardForm.get('theme')?.value === 'light'}" (click)="view.setTheme('light')"
                id="wizard-theme-light-btn">
                <i class="fas fa-sun" id="wizard-theme-light-icon"></i>
                <span id="wizard-theme-light-text">{{ view.translate('settings.light') }}</span>
              </button>
              <button type="button" class="btn theme-btn dark-btn"
                [ngClass]="{'active': view.wizardForm.get('theme')?.value === 'dark'}" (click)="view.setTheme('dark')"
                id="wizard-theme-dark-btn">
                <i class="fas fa-moon" id="wizard-theme-dark-icon"></i>
                <span id="wizard-theme-dark-text">{{ view.translate('settings.dark') }}</span>
              </button>
            </div>
          </div>

          <!-- Language selection -->
          <div class="preference-section" id="wizard-language-section">
            <h3 id="wizard-language-title">{{ view.translate('wizard.language_preference') }}</h3>
            <div class="language-selector" id="wizard-language-selector">
              <button type="button" class="btn"
                [ngClass]="{'btn-primary': view.wizardForm.get('language')?.value === 'es', 'btn-outline-secondary': view.wizardForm.get('language')?.value !== 'es'}"
                (click)="view.setLanguage('es')" id="wizard-language-es-btn">
                <span class="language-flag">🇪🇸</span> {{ view.translate('settings.spanish') }}
              </button>
              <button type="button" class="btn"
                [ngClass]="{'btn-primary': view.wizardForm.get('language')?.value === 'en', 'btn-outline-secondary': view.wizardForm.get('language')?.value !== 'en'}"
                (click)="view.setLanguage('en')" id="wizard-language-en-btn">
                <span class="language-flag">🇬🇧</span> {{ view.translate('settings.english') }}
              </button>
              <button type="button" class="btn"
                [ngClass]="{'btn-primary': view.wizardForm.get('language')?.value === 'pt', 'btn-outline-secondary': view.wizardForm.get('language')?.value !== 'pt'}"
                (click)="view.setLanguage('pt')" id="wizard-language-pt-btn">
                <span class="language-flag">🇵🇹</span> {{ view.translate('settings.portuguese') }}
              </button>
              <button type="button" class="btn"
                [ngClass]="{'btn-primary': view.wizardForm.get('language')?.value === 'fr', 'btn-outline-secondary': view.wizardForm.get('language')?.value !== 'fr'}"
                (click)="view.setLanguage('fr')" id="wizard-language-fr-btn">
                <span class="language-flag">🇫🇷</span> {{ view.translate('settings.french') }}
              </button>
              <button type="button" class="btn"
                [ngClass]="{'btn-primary': view.wizardForm.get('language')?.value === 'ja', 'btn-outline-secondary': view.wizardForm.get('language')?.value !== 'ja'}"
                (click)="view.setLanguage('ja')" id="wizard-language-ja-btn">
                <span class="language-flag">🇯🇵</span> {{ view.translate('settings.japanese') }}
              </button>
            </div>
          </div>

          <!-- Other preferences -->
          <div class="preference-section" id="wizard-other-section">
            <h3 id="wizard-other-title">{{ view.translate('wizard.other_preferences') }}</h3>
            <div class="form-check" id="wizard-notifications-check">
              <input class="form-check-input" type="checkbox" id="notifications" formControlName="notifications">
              <label class="form-check-label" for="notifications">{{ view.translate('wizard.enable_notifications') }}</label>
            </div>
            <div class="form-check" id="wizard-datacollection-check">
              <input class="form-check-input" type="checkbox" id="dataCollection" formControlName="dataCollection">
              <label class="form-check-label" for="dataCollection">{{ view.translate('wizard.allow_data_collection') }}</label>
              <div class="form-text">{{ view.translate('wizard.data_collection_info') }}</div>
            </div>
          </div>
        </form>
      </div>

      <!-- Step 3: Profile -->
      <div *ngIf="view.currentStep === 2" class="step-profile" id="wizard-step-profile">
        <h1 class="step-title" id="wizard-step-profile-title">{{ view.translate(view.steps[view.currentStep].title) }}</h1>
        <p class="step-description" id="wizard-step-profile-description">{{ view.translate(view.steps[view.currentStep].description) }}</p>

        <form [formGroup]="view.wizardForm" class="profile-form" id="wizard-profile-form">
          <div class="form-group" id="wizard-profile-firstname-group">
            <label for="firstName">{{ view.translate('wizard.first_name') }} *</label>
            <input type="text" id="firstName" class="form-control" formControlName="firstName">
            <div *ngIf="view.wizardForm.get('firstName')?.invalid && view.wizardForm.get('firstName')?.touched" class="form-error">
              {{ view.translate('wizard.first_name_required') }}
            </div>
          </div>

          <div class="form-group" id="wizard-profile-secondname-group">
            <label for="secondName">{{ view.translate('wizard.second_name') }} *</label>
            <input type="text" id="secondName" class="form-control" formControlName="secondName">
            <div *ngIf="view.wizardForm.get('secondName')?.invalid && view.wizardForm.get('secondName')?.touched" class="form-error">
              {{ view.translate('wizard.second_name_required') }}
            </div>
          </div>

          <div class="form-group" id="wizard-profile-job-group">
            <label for="jobTitle">{{ view.translate('wizard.job_title') }} *</label>
            <input type="text" id="jobTitle" class="form-control" formControlName="jobTitle">
            <div *ngIf="view.wizardForm.get('jobTitle')?.invalid && view.wizardForm.get('jobTitle')?.touched" class="form-error">
              {{ view.translate('wizard.job_required') }}
            </div>
          </div>

          <div class="form-group" id="wizard-profile-company-group">
            <label for="company">{{ view.translate('wizard.company') }}</label>
            <input type="text" id="company" class="form-control" formControlName="company" readonly>
            <div class="form-text">{{ view.translate('invite.company_from_invite') }}</div>
          </div>

          <div class="form-row" id="wizard-profile-org-row">
            <div class="form-group" id="wizard-profile-timezone-group">
              <label for="timezone">{{ view.translate('wizard.timezone') }} *</label>
              <input #tzSearch type="text" class="form-control mb-2"
                [attr.placeholder]="view.translate('wizard.timezone_search')"
                (input)="view.onTimezoneQueryChange(tzSearch.value)"
                (keyup.enter)="view.onTimezoneEnter()"
                [value]="view.timezoneQuery" />
              <select id="timezone" class="form-control" formControlName="timezone">
                <option value="" disabled>{{ view.translate('wizard.timezone_select') }}</option>
                <option *ngFor="let tz of view.timezones" [value]="tz.value">{{ tz.label }}</option>
              </select>
              <div *ngIf="view.timezones.length === 0" class="form-text">{{ view.translate('wizard.timezone_no_results') }}</div>
              <div *ngIf="view.wizardForm.get('timezone')?.invalid && view.wizardForm.get('timezone')?.touched" class="form-error">
                {{ view.translate('wizard.timezone_required') }}
              </div>
            </div>
          </div>
        </form>
      </div>
